import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkCjkFriendly from "remark-cjk-friendly";

interface WebinarPartnerAboutProps {
  aboutPartner: string;
  partnerTitle?: string;
}

/**
 * "About the partner" callout (e.g. About Capital Cell).
 * Rendered inside the webinar body by default, or below "Who should attend"
 * when the article content carries `<!-- partner_after_audience -->`.
 */
const WebinarPartnerAbout = ({ aboutPartner, partnerTitle = "" }: WebinarPartnerAboutProps) => {
  if (!aboutPartner) return null;

  return (
    <div className="bg-secondary/40 border border-border rounded-2xl px-6 sm:px-8 py-8">
      <h3 className="text-xl sm:text-2xl font-bold text-foreground mb-5">
        {partnerTitle || "About the partner"}
      </h3>
      <div className="prose prose-base max-w-none prose-p:text-foreground/75 prose-p:leading-[1.85] prose-strong:text-foreground prose-strong:font-semibold [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-2 prose-li:text-foreground/75 [&_li]:marker:text-primary/60">
        <ReactMarkdown
          remarkPlugins={[remarkGfm, remarkCjkFriendly]}
          components={{
            img: ({ src, alt }: any) => (
              <img src={src} alt={alt || partnerTitle} className="h-12 w-auto mb-4" loading="lazy" />
            ),
            a: ({ href, children }: any) => (
              <a href={href} target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                {children}
              </a>
            ),
          }}
        >
          {aboutPartner}
        </ReactMarkdown>
      </div>
    </div>
  );
};

export default WebinarPartnerAbout;
